// extracted by mini-css-extract-plugin
export default {"checkbox_wrapper":"Checkbox_checkbox_wrapper__5gqCn"};